import toPath from 'lodash/toPath';
/**
 * Given an object and a path, traverse the object to find the value,
 * and return it.
 */
export function deepGet(obj: any, path: string | string[]) {
  const segments = toPath(path);
  let i = 0;
  let val = obj;
  for (; i < segments.length; i++) {
    if (val === undefined) {
      return val;
    }
    val = val[segments[i]];
  }
  return val;
}

export function parseCountryList(country_list: any){
  return country_list.map((item: any) => {
    item.label = item.countryName;
    item.value = parseInt(item.countriesId);
    delete item["countryName"];
    delete item["countriesId"];
    return item;
  });
}
